import { JobShortURL } from './JobShortUrl.model';
import { JobSkill } from './jobSkill.model';

export class JobContent {
  constructor(
    public createdDate: string = '1900-01-01',
    public createdBy: string = '',
    public id: string = '',
    public externalId: string = '',
    public name: string = '',
    public category: string = '',
    public subCategory: string = '',
    public description: string = '',
    public location: string = '',
    public countries: string[] = [],
    public image: string = '',
    public company: string = '',
    public aboutUs: string = '',
    public email: string = '',
    public postedDate: string = '1900-01-01',
    public featured: boolean = false,
    public shortURL: JobShortURL = new JobShortURL(),
    public published: boolean = true,
    public applicants: number = 0,
    public closed: boolean = false,
    public skills: JobSkill[] = [],
    /** True for remote_job imports (LATAM / remote search), not local job rows. */
    public remote: boolean = false
  ) {}
}
